'use strict';

/*global services*/

function K2Logging() {
  this.init();
}

K2Logging.prototype = $.extend({}, {
  constructor: 'K2Logging',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    window.onerror = function (msg, url, lineNo, columnNo, error) {
      _this.sendErrorLog(msg, url, lineNo, columnNo, error);

      return false;
    };

    return _this;
  },

  //----------------------------------------------------------------------------

  sendErrorLog: function sendErrorLog(msg, url, lineNo, columnNo, error) {
    var _this = this;

    $.post(services.get('router').path('logging_js_log'), { msg: msg, url: url, line_no: lineNo, column_no: columnNo, error: error });

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.registerCallbacks();

    return _this;
  }
});
